import styled from '@emotion/styled'
import React from 'react'

const TickerItem = styled.h1`
  margin: 0 40px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  font-family: ${(props) => props.fontFamily ? `"${props.fontFamily}" !important` : 'Objectivity !important'};
  ${(props) => (props.size === 'small' ? 'min-height: 60px' : props.size === 'large' ? 'min-height: 150px;' : 'min-height: 75px;')};
`

const TickerHeading = ({ title, titlePt2, color, BGcolor, size, overlapCompensation, fontFamily }) => {
  const titleSplit = title?.split(',')

  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      <div id={`banner-${title}`} style={{ position: 'absolute', top: -160, height: 1 }} />
      <div className="ticker animate ticker-v2 animate-v2" style={{ margin: 0, backgroundColor: BGcolor, ...(overlapCompensation ? { paddingBottom: 50 } : {}) }}>
        <div className="ticker_list">
          {
            (new Array(Math.ceil(title?.length / 2)).fill(0)).map((_, key) => {
              return titleSplit.map((word, i) =>
                <TickerItem key={`${key}-${i}`} style={{ color: color }} size={size} fontFamily={fontFamily?.replace('_', ' ')}>
                  <span
                    style={{
                      fontSize: size === 'small' ? '24px' : size === 'large' ? '60px' : '40px',
                      fontWeight: '400',
                      fontStyle: 'normal',
                      marginRight: '0.4em'
                    }}
                  >
                    {word}{" "}
                  </span>
                </TickerItem>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

const TickerV2 = ({ data, overlapCompensation }) => {
  return (
    <div
      style={{
        overflow: 'hidden',
        backgroundColor: data.backgroundColour,
      }}
    >
      <TickerHeading fontFamily={data.TickerFont} overlapCompensation={overlapCompensation} title={data.TickerText} titlePt2={data?.TickerTextPt2} BGcolor={data.BGcolor} data={data} size={data.TickerSize} color={data.TickerColor} />
    </div>
  )
}

export default TickerV2
